import { Select } from "components/shared/form";
import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { paths } from "helpers/paths";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { list } from "sources/books/transportColumns";
import { numbersList } from "sources/books/trucks";
import { addCars } from "sources/books/usersGroups";

export default function AddCarToGroup(props) {
    const [data, setData] = useState({ carIds: null, transportColumnId: null, groupId: props.groupId });
    const [failedCars, setFailedCars] = useState([]);
    const [loading, setLoading] = useState(false);
    const handleSubmit = () => {
        setLoading(true);
        addCars(data).then((res) => {
            if (res) {
                props.mergeParams();
                if (res.failedCars?.length > 0) {
                    setFailedCars(res.failedCars);
                } else {
                    props.back();
                }
            }
            setLoading(false);
        });
    };

    const forceMove = () => {
        setLoading(true);
        addCars({ ...data, forceMoveOnConflicting: true }).then((res) => {
            if (res) {
                props.mergeParams();
                props.back();
            }
            setLoading(false);
        });
    };

    return (
        <div className={loading ? "loading" : ""}>
            {failedCars?.length > 0 ? (
                <div>
                    <div className="alert alert-warning font-size-14">
                        Не удалось добавить следующие машины, так как они состоят в других группах.
                        <br />
                        Вы можете перенести машины в эту группу и они будут удалены из своих текущих групп.
                    </div>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th />
                                <th>Машина</th>
                                <th>Группа</th>
                            </tr>
                        </thead>
                        <tbody>
                            {failedCars.map((item, index) => (
                                <tr key={item.carId}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <Link to={paths.trucksShow(item.carId)} target="_blank">
                                            {item.carNumber}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to={paths.usersGroupsShow(item.groupId)} target="_blank">
                                            {item.groupName}
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-end">
                        <div className="btn btn-sm btn-brand" onClick={forceMove}>
                            Перенести машины в группу
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <Select
                        {...defaultMultipleSelectProps}
                        label="Машины"
                        inputProps={{ name: "carIds" }}
                        onChange={({ name, value }) => setData({ ...data, [name]: value })}
                        value={data.carIds}
                        url={numbersList}
                        propName="number"
                        menuPortalTarget={document.body}
                        components={{ ValueContainer }}
                    />
                    <Select
                        label="Транспортная колонна"
                        inputProps={{ name: "transportColumnId" }}
                        onChange={({ name, value }) => setData({ ...data, [name]: value })}
                        value={data.transportColumnId}
                        url={list}
                        propName="name"
                        menuPortalTarget={document.body}
                    />
                    <div className="d-flex justify-content-end">
                        <div className="btn btn-sm btn-brand" onClick={handleSubmit}>
                            Сохранить
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
